export default __webpack_public_path__ + "static/media/vip-icon.e7db53ed.webp";